module.exports = __webpack_public_path__ + "img/verem savaş .4cbd5de0.png";